import { render, staticRenderFns } from "./watchlistButton.vue?vue&type=template&id=a96ac816&"
import script from "./watchlistButton.vue?vue&type=script&lang=js&"
export * from "./watchlistButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports